import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 2560.000000 2560.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,2560.000000) scale(0.100000,-0.100000)" >
				<path d="M10138 18872 c-16 -9 -33 -32 -39 -52 -6 -19 -22 -59 -35 -87 -13
-29 -35 -77 -48 -105 -13 -29 -27 -64 -31 -78 -4 -14 -16 -36 -26 -49 -11 -13
-19 -33 -19 -43 0 -11 -11 -41 -24 -67 -35 -66 -76 -156 -76 -167 0 -5 -13
-36 -29 -69 -67 -142 -81 -173 -81 -187 0 -8 -9 -26 -19 -40 -11 -13 -23 -38
-27 -54 -4 -16 -17 -47 -29 -69 -13 -22 -26 -53 -29 -69 -4 -17 -16 -42 -27
-57 -10 -15 -19 -33 -19 -40 0 -13 -18 -54 -76 -174 -13 -28 -24 -54 -24 -59
0 -8 -24 -62 -80 -181 -11 -22 -24 -57 -30 -77 -6 -20 -17 -42 -25 -48 -7 -6
-17 -26 -20 -43 -4 -18 -15 -45 -25 -62 -10 -16 -23 -48 -30 -70 -7 -22 -21
-51 -31 -64 -11 -13 -19 -31 -19 -40 0 -15 -11 -40 -75 -176 -13 -27 -27 -61
-31 -75 -4 -14 -15 -37 -25 -52 -11 -14 -19 -33 -19 -41 0 -8 -11 -35 -25 -61
-14 -26 -25 -52 -25 -57 0 -6 -14 -40 -31 -77 -16 -37 -38 -85 -48 -107 -10
-22 -25 -56 -32 -75 -7 -19 -21 -47 -31 -62 -10 -14 -18 -33 -18 -42 0 -9 -11
-37 -24 -63 -45 -91 -75 -158 -82 -183 -3 -14 -12 -32 -19 -40 -7 -8 -16 -26
-20 -40 -4 -14 -17 -47 -30 -75 -36 -79 -83 -188 -89 -212 -4 -11 -13 -27 -21
-33 -8 -7 -15 -20 -15 -29 0 -9 -13 -43 -30 -76 -16 -33 -30 -66 -30 -73 0 -7
-9 -30 -19 -50 -39 -73 -80 -168 -85 -194 -4 -15 -12 -33 -19 -40 -8 -7 -22
-37 -31 -66 -10 -28 -22 -54 -26 -57 -5 -3 -15 -25 -21 -48 -6 -23 -20 -54
-30 -68 -10 -15 -19 -32 -19 -39 0 -10 -29 -76 -86 -195 -13 -28 -24 -55 -24
-60 0 -6 -9 -28 -19 -50 -44 -90 -80 -172 -86 -197 -4 -15 -13 -32 -21 -39 -8
-6 -14 -19 -14 -29 0 -9 -13 -44 -29 -76 -54 -113 -81 -175 -81 -187 0 -7 -11
-29 -25 -49 -14 -20 -25 -45 -25 -55 0 -10 -11 -36 -25 -58 -13 -22 -25 -46
-25 -53 0 -13 -44 -113 -79 -182 -10 -19 -21 -48 -25 -64 -4 -17 -16 -42 -26
-56 -10 -14 -22 -39 -26 -56 -4 -16 -15 -45 -25 -64 -36 -70 -79 -169 -79
-182 0 -7 -9 -26 -20 -43 -11 -16 -25 -48 -31 -70 -6 -22 -17 -47 -24 -55 -7
-8 -16 -26 -20 -40 -8 -27 -55 -134 -84 -190 -10 -19 -21 -48 -25 -64 -4 -16
-16 -41 -27 -54 -10 -14 -19 -32 -19 -41 0 -9 -11 -38 -24 -66 -47 -97 -74
-160 -85 -197 -7 -20 -18 -42 -26 -48 -7 -6 -17 -26 -20 -43 -4 -18 -18 -51
-31 -74 -13 -23 -24 -47 -24 -54 0 -11 -11 -36 -76 -174 -13 -27 -26 -61 -30
-75 -4 -14 -15 -37 -25 -52 -11 -14 -19 -32 -19 -40 0 -7 -14 -40 -30 -73 -16
-33 -30 -67 -30 -76 0 -9 -7 -22 -14 -29 -8 -6 -20 -28 -26 -48 -6 -20 -19
-55 -30 -77 -57 -122 -80 -175 -80 -188 0 -8 -9 -25 -19 -39 -11 -13 -24 -42
-30 -63 -6 -22 -17 -49 -24 -60 -8 -11 -20 -38 -27 -60 -7 -22 -21 -51 -31
-64 -24 -30 -25 -86 -3 -95 29 -11 819 -7 852 5 25 9 34 19 43 52 6 22 17 50
24 61 8 12 23 47 35 79 12 31 25 57 30 57 4 0 11 16 14 35 4 20 18 57 32 82
13 25 24 52 24 60 0 8 8 27 19 41 10 15 24 45 31 67 7 22 21 53 31 70 11 16
19 36 19 44 0 13 14 46 81 186 16 33 29 67 29 75 0 8 9 26 20 40 11 14 20 33
20 42 0 10 14 44 30 76 17 33 30 65 30 71 0 7 9 29 19 49 37 69 81 171 81 185
0 8 8 25 18 38 10 13 24 45 32 71 7 26 18 53 26 59 7 5 16 25 19 42 4 18 17
50 30 72 12 22 26 54 29 72 4 17 13 37 21 43 8 6 17 26 20 43 4 18 18 51 31
74 13 23 24 48 24 55 0 7 14 40 30 73 16 33 30 66 30 73 0 8 9 25 20 39 11 14
20 33 20 42 0 9 11 38 24 66 59 122 86 185 86 197 0 7 8 27 19 44 10 17 22 41
26 55 8 28 46 112 81 182 13 26 24 53 24 59 0 13 32 85 76 171 13 26 24 53 24
60 0 7 11 32 24 57 13 25 29 63 36 85 7 22 18 47 25 55 7 8 18 34 24 57 7 23
16 45 21 48 4 3 14 22 20 43 6 20 22 61 35 90 14 28 36 76 50 105 13 28 27 63
31 77 4 14 14 36 24 50 9 14 20 41 24 61 4 21 13 42 20 48 8 7 17 24 20 39 4
15 18 50 31 77 13 28 38 84 55 125 16 41 39 92 50 112 11 20 20 43 20 50 0 7
11 35 24 63 51 107 76 162 76 169 0 4 14 38 31 74 17 37 42 90 55 118 13 28
24 57 24 64 0 6 11 33 23 59 13 25 36 70 50 99 15 28 27 58 27 66 0 7 11 34
25 60 14 26 25 52 25 59 0 7 13 39 29 72 65 136 81 173 81 183 0 6 11 32 25
58 14 26 25 53 25 61 0 8 8 27 19 41 10 15 24 45 31 67 7 22 19 49 27 60 7 11
18 38 24 60 6 22 17 47 24 55 7 8 18 33 25 55 7 22 20 54 30 70 10 17 24 49
31 73 7 23 18 47 26 53 7 6 13 19 13 28 0 9 11 36 24 61 13 25 29 64 35 86 6
23 18 47 26 54 8 7 15 20 15 29 0 9 13 43 30 76 16 33 30 67 30 75 0 8 12 33
25 55 14 22 25 48 25 57 0 10 11 39 24 65 14 27 37 75 52 108 14 33 37 83 49
110 13 28 27 64 31 80 4 17 13 37 20 46 8 9 21 39 29 67 9 29 19 52 24 52 4 0
15 25 25 55 9 30 21 57 26 60 5 3 23 -1 39 -10 22 -11 33 -27 42 -58 6 -23 17
-49 24 -57 7 -8 19 -35 26 -60 7 -25 21 -56 31 -69 10 -13 18 -31 18 -40 0 -9
11 -38 24 -66 57 -118 86 -184 86 -195 0 -6 11 -32 25 -58 14 -26 25 -54 25
-62 0 -8 11 -33 25 -55 13 -22 25 -46 25 -54 0 -8 11 -38 25 -68 54 -115 73
-159 80 -182 4 -14 16 -38 26 -55 11 -17 19 -37 19 -44 0 -12 27 -75 86 -197
13 -28 24 -56 24 -64 0 -7 8 -28 19 -45 10 -17 24 -49 31 -71 7 -22 18 -47 25
-55 8 -8 17 -28 21 -45 4 -16 17 -50 30 -75 13 -25 24 -51 24 -59 0 -7 8 -28
19 -45 10 -17 24 -49 31 -71 7 -22 21 -51 31 -64 11 -13 19 -33 19 -44 0 -11
11 -39 24 -61 13 -23 26 -54 30 -70 4 -17 15 -41 25 -55 10 -14 24 -47 31 -73
7 -27 16 -48 21 -48 5 0 16 -25 24 -55 9 -30 20 -57 25 -60 5 -3 14 -22 20
-43 6 -20 22 -59 34 -87 67 -142 76 -163 76 -176 0 -8 11 -32 25 -54 13 -22
25 -48 25 -58 0 -10 11 -37 24 -60 13 -23 30 -61 37 -84 7 -24 15 -43 19 -43
4 0 12 -18 19 -41 7 -22 23 -61 37 -86 13 -25 24 -53 24 -61 0 -8 9 -29 19
-46 11 -17 25 -50 32 -74 7 -23 18 -47 26 -53 7 -6 13 -19 13 -29 0 -9 11 -37
23 -61 13 -24 30 -62 37 -84 7 -22 18 -47 25 -55 8 -8 17 -28 21 -45 4 -16 17
-50 30 -75 13 -25 24 -52 24 -60 0 -8 11 -33 25 -55 13 -22 25 -48 25 -57 0
-10 11 -40 25 -68 14 -27 36 -73 50 -100 14 -28 25 -56 25 -64 0 -7 11 -33 24
-58 13 -24 27 -55 31 -69 7 -24 37 -92 81 -184 13 -28 24 -57 24 -65 0 -9 7
-25 15 -37 9 -12 22 -42 31 -65 8 -24 23 -62 34 -85 11 -24 29 -62 40 -85 11
-24 26 -62 34 -86 9 -23 22 -53 31 -65 8 -12 15 -28 15 -36 0 -14 30 -83 76
-174 13 -26 24 -53 24 -60 0 -6 14 -39 30 -72 16 -33 30 -67 30 -76 0 -9 9
-27 19 -41 11 -13 23 -38 27 -54 4 -16 18 -49 31 -73 12 -24 23 -51 23 -60 0
-9 12 -34 25 -56 14 -22 25 -46 25 -54 0 -13 14 -46 81 -186 16 -33 29 -64 29
-69 0 -8 20 -53 66 -151 7 -16 20 -49 29 -73 8 -23 21 -53 30 -65 8 -12 15
-27 15 -34 0 -7 14 -42 30 -76 17 -35 30 -71 30 -79 0 -8 9 -26 19 -40 11 -13
24 -42 30 -63 6 -22 20 -53 31 -70 11 -16 20 -39 20 -50 0 -11 12 -38 25 -60
14 -22 25 -46 25 -54 0 -13 14 -46 81 -186 16 -33 29 -66 29 -73 0 -7 14 -33
30 -58 l31 -44 847 0 c682 1 867 3 947 15 313 45 377 55 395 65 10 5 54 15 97
21 43 6 98 19 123 30 25 11 65 23 90 26 25 3 61 14 80 23 19 10 53 20 75 24
22 4 58 16 80 26 22 11 58 23 80 29 43 10 161 56 185 71 8 6 25 15 38 20 12 6
32 14 45 20 12 5 29 14 37 19 8 5 77 40 152 77 76 38 159 81 185 96 27 15 68
37 93 50 51 27 132 78 140 87 3 4 18 15 35 25 16 11 34 23 40 28 87 71 151
121 167 129 21 11 24 14 103 85 28 24 67 59 88 77 20 17 77 70 125 117 75 73
121 122 257 276 32 36 64 77 83 105 30 47 56 83 107 151 75 100 89 120 103
148 6 14 26 45 42 70 17 25 39 64 50 86 11 23 27 47 35 54 8 7 15 18 15 25 0
7 8 23 19 36 10 13 24 42 32 64 7 22 21 51 30 65 9 14 20 36 24 50 4 14 18 45
31 70 13 25 24 52 24 61 0 9 8 27 19 40 10 13 24 47 30 76 7 29 21 69 32 90
10 20 19 46 19 58 0 11 9 37 20 57 10 20 26 63 34 95 8 32 21 76 30 98 8 22
15 54 16 72 0 18 11 65 24 105 13 40 27 98 30 128 4 30 17 105 29 165 21 106
22 132 22 710 0 526 -2 607 -16 660 -10 33 -22 103 -29 155 -7 52 -21 121 -31
153 -11 32 -24 90 -29 129 -6 39 -15 76 -20 82 -5 6 -16 43 -26 81 -9 39 -21
76 -27 83 -5 7 -18 40 -28 75 -25 89 -56 176 -78 222 -11 22 -42 87 -70 145
-28 58 -51 110 -51 116 0 6 -11 27 -24 47 -13 19 -27 46 -31 58 -4 13 -15 33
-25 44 -18 21 -34 48 -70 122 -11 23 -25 45 -31 49 -6 3 -19 25 -28 48 -10 23
-26 47 -35 55 -9 7 -16 18 -16 24 0 6 -9 20 -20 32 -12 11 -57 70 -102 130
-44 61 -88 117 -97 125 -9 8 -59 64 -111 125 -119 136 -183 203 -285 291 -44
38 -100 88 -125 111 -25 24 -53 46 -62 49 -10 3 -18 9 -18 13 0 4 -30 27 -67
51 -38 24 -75 50 -83 57 -63 53 -88 71 -106 77 -12 4 -29 15 -39 26 -10 11
-22 20 -27 20 -5 0 -40 19 -78 43 -95 58 -152 89 -240 132 -41 20 -95 46 -120
59 -25 13 -58 27 -75 30 -16 4 -37 13 -45 20 -8 8 -39 21 -67 30 -29 10 -55
21 -58 26 -3 5 -31 14 -63 20 -31 7 -66 18 -77 25 -12 7 -45 18 -76 24 -30 6
-67 18 -82 26 -16 8 -61 21 -101 29 -39 9 -88 22 -106 30 -19 7 -59 17 -89 21
-30 4 -80 16 -110 27 -31 10 -103 23 -161 28 -58 5 -136 17 -175 26 -65 17
-194 18 -1816 21 -1452 3 -1748 1 -1757 -10 -14 -16 1 -79 23 -97 8 -7 15 -19
15 -27 0 -22 68 -179 136 -316 13 -26 24 -54 24 -62 0 -8 12 -39 27 -67 60
-120 71 -144 78 -175 3 -17 13 -38 22 -45 13 -11 288 -14 1472 -19 1290 -5
1464 -8 1524 -22 37 -9 106 -19 155 -22 48 -4 119 -15 157 -25 39 -10 93 -21
120 -25 28 -4 79 -15 115 -26 36 -10 90 -25 120 -33 30 -8 75 -21 100 -30 25
-8 65 -22 90 -30 76 -23 112 -37 175 -67 33 -15 70 -30 83 -34 12 -3 22 -11
22 -16 0 -5 6 -9 13 -9 14 0 160 -72 180 -89 7 -5 44 -26 82 -46 83 -44 130
-74 207 -135 31 -25 75 -58 97 -75 35 -26 81 -67 251 -230 60 -56 115 -117
178 -195 34 -41 68 -83 77 -93 9 -10 45 -62 80 -115 36 -53 69 -102 74 -108 5
-6 19 -29 31 -50 11 -21 34 -61 51 -89 16 -27 38 -68 49 -90 11 -22 26 -51 34
-65 44 -84 66 -132 66 -143 0 -7 11 -28 24 -47 13 -19 27 -51 31 -70 4 -19 16
-51 25 -70 10 -20 22 -54 26 -75 3 -22 15 -56 24 -75 10 -20 21 -58 25 -85 4
-28 16 -71 26 -97 10 -25 21 -70 24 -100 4 -29 15 -85 26 -123 10 -39 23 -122
28 -185 6 -63 16 -162 22 -220 15 -128 15 -454 0 -570 -6 -47 -15 -135 -20
-196 -6 -62 -19 -147 -30 -190 -10 -44 -22 -101 -26 -129 -4 -27 -15 -72 -25
-100 -10 -27 -21 -70 -24 -93 -4 -24 -15 -60 -25 -80 -10 -21 -22 -56 -26 -79
-4 -24 -11 -45 -15 -48 -5 -3 -16 -29 -25 -58 -10 -28 -25 -68 -35 -87 -20
-38 -60 -125 -85 -180 -8 -19 -28 -57 -44 -85 -17 -27 -39 -68 -51 -90 -38
-73 -72 -130 -79 -135 -5 -3 -16 -20 -26 -39 -19 -37 -20 -38 -65 -92 -16 -20
-30 -41 -30 -46 0 -18 -121 -155 -250 -283 -122 -122 -198 -189 -337 -298
-116 -91 -145 -112 -154 -112 -4 0 -14 -6 -22 -14 -8 -8 -29 -22 -48 -30 -19
-9 -56 -29 -84 -45 -50 -29 -276 -143 -370 -186 -27 -13 -66 -27 -85 -31 -19
-3 -44 -12 -55 -19 -11 -7 -45 -18 -75 -24 -30 -7 -65 -18 -77 -26 -12 -8 -55
-20 -95 -26 -40 -6 -89 -18 -107 -25 -19 -8 -67 -19 -105 -25 -39 -5 -97 -16
-129 -24 -31 -8 -106 -19 -165 -25 -59 -5 -163 -17 -232 -26 -89 -12 -232 -18
-500 -21 -404 -4 -413 -3 -436 47 -6 14 -23 50 -37 80 -14 30 -29 66 -33 80
-4 14 -15 36 -25 49 -11 13 -19 31 -19 39 0 15 -42 112 -80 184 -11 20 -20 43
-20 50 0 7 -14 40 -30 73 -17 33 -30 67 -30 76 0 9 -7 22 -14 29 -8 6 -20 28
-27 48 -11 35 -33 87 -85 197 -13 28 -26 61 -30 75 -3 14 -12 32 -19 40 -7 8
-18 32 -24 54 -5 21 -16 46 -24 55 -8 9 -20 34 -27 56 -7 22 -18 50 -26 62 -8
12 -21 43 -30 69 -9 26 -22 53 -29 60 -7 8 -16 31 -20 53 -4 22 -13 45 -20 51
-8 6 -21 35 -31 63 -9 29 -22 59 -30 67 -7 8 -16 29 -20 45 -4 17 -18 50 -31
74 -12 24 -23 50 -23 58 0 8 -8 27 -19 41 -10 15 -21 38 -25 52 -4 14 -17 48
-30 75 -66 140 -76 163 -76 177 0 8 -9 26 -19 39 -10 14 -25 45 -32 69 -7 25
-19 52 -26 61 -8 9 -19 34 -24 55 -6 22 -17 46 -24 54 -7 8 -20 39 -29 67 -10
29 -21 55 -26 58 -5 3 -16 29 -26 58 -9 28 -22 59 -30 67 -7 8 -16 29 -20 45
-4 17 -15 46 -25 65 -37 73 -79 169 -79 183 0 8 -9 25 -19 39 -11 13 -24 42
-30 63 -6 22 -20 54 -31 70 -11 17 -20 38 -20 47 0 10 -11 39 -24 65 -30 57
-69 145 -87 193 -7 19 -19 41 -26 48 -7 7 -15 29 -19 50 -4 20 -15 48 -25 61
-11 13 -19 29 -19 35 0 6 -14 38 -30 71 -16 33 -30 67 -30 76 0 9 -8 27 -19
40 -10 13 -24 42 -31 64 -7 22 -18 49 -25 60 -6 11 -18 38 -25 60 -7 22 -18
47 -25 55 -8 8 -17 29 -20 45 -4 17 -17 48 -30 70 -12 22 -25 53 -29 69 -4 16
-16 41 -27 54 -10 14 -19 32 -19 41 0 9 -11 38 -24 66 -57 119 -86 185 -86
195 0 7 -8 24 -18 38 -10 15 -25 48 -32 75 -7 26 -16 47 -21 47 -4 0 -13 17
-19 38 -13 40 -49 120 -86 193 -13 26 -24 56 -24 67 0 10 -9 30 -19 44 -11 13
-23 38 -27 54 -4 16 -17 49 -30 74 -30 59 -74 157 -74 166 0 7 -26 66 -80 179
-11 22 -24 57 -30 77 -6 20 -17 42 -25 48 -7 6 -17 26 -21 43 -3 18 -17 52
-30 77 -13 25 -24 51 -24 58 0 8 -9 26 -19 41 -11 15 -23 40 -27 57 -4 16 -17
47 -29 69 -13 22 -26 53 -29 69 -4 16 -16 41 -27 54 -10 14 -19 32 -19 41 0 9
-14 43 -30 76 -16 33 -30 67 -30 76 0 9 -7 22 -14 29 -8 6 -20 28 -26 48 -6
20 -19 55 -30 77 -61 130 -80 173 -80 187 0 8 -9 26 -19 40 -11 14 -25 46 -32
71 -6 26 -15 47 -19 47 -5 0 -16 24 -25 53 -10 28 -23 59 -31 67 -7 8 -16 29
-20 45 -3 17 -17 50 -29 75 -59 118 -85 176 -85 193 0 10 -11 22 -26 27 -15 6
-186 10 -417 10 -352 -1 -395 -2 -419 -18z"/>
<path d="M12558 17497 c-24 -8 -20 -33 17 -112 57 -124 74 -162 81 -185 4 -14
15 -36 25 -49 11 -13 19 -31 19 -40 0 -9 11 -38 24 -66 47 -98 74 -160 86
-197 6 -21 15 -40 20 -43 5 -3 16 -27 25 -54 8 -26 28 -59 43 -74 l27 -26
1505 -4 c1366 -4 1511 -6 1570 -21 36 -9 113 -23 172 -31 58 -8 133 -23 167
-35 33 -11 75 -20 93 -20 18 -1 51 -8 73 -16 22 -9 63 -22 90 -30 28 -8 62
-22 77 -30 16 -8 49 -21 75 -29 74 -21 186 -65 203 -80 8 -7 32 -16 53 -20 21
-4 44 -13 51 -20 7 -8 34 -23 60 -35 25 -12 46 -26 46 -31 0 -5 9 -9 20 -9 14
0 20 7 20 23 0 20 -16 46 -104 177 -13 19 -31 41 -40 49 -9 7 -16 20 -16 27 0
8 -3 14 -8 14 -4 0 -42 43 -85 94 -43 52 -115 128 -160 168 -81 73 -91 81
-144 126 -24 20 -106 81 -200 147 -13 9 -58 34 -100 57 -43 22 -89 49 -102 59
-13 11 -30 19 -38 19 -8 0 -38 12 -67 26 -126 65 -145 74 -158 74 -7 0 -29 9
-49 19 -20 11 -58 26 -86 34 -28 8 -63 22 -79 30 -16 8 -54 18 -84 22 -30 4
-70 13 -88 21 -19 7 -73 18 -120 24 -48 6 -125 18 -172 28 -77 15 -210 17
-1403 22 -725 3 -1327 2 -1339 -3z"/>
<path d="M9425 13643 c-10 -21 -24 -44 -32 -51 -7 -7 -13 -20 -13 -28 0 -15
-25 -74 -76 -179 -13 -28 -24 -55 -24 -60 0 -6 -13 -37 -29 -70 -65 -137 -81
-173 -81 -183 0 -7 -11 -33 -24 -59 -39 -79 -74 -157 -81 -182 -4 -14 -18 -45
-31 -69 -13 -25 -24 -52 -24 -61 0 -9 -9 -27 -20 -41 -11 -14 -20 -32 -20 -40
0 -8 -11 -37 -24 -65 -14 -27 -39 -84 -56 -125 -17 -41 -42 -95 -55 -120 -12
-25 -26 -59 -30 -77 -3 -17 -12 -37 -20 -43 -8 -6 -17 -26 -20 -43 -4 -18 -15
-45 -25 -62 -10 -16 -23 -48 -30 -70 -7 -22 -18 -47 -25 -55 -7 -8 -20 -39
-29 -67 -10 -29 -22 -55 -26 -58 -5 -3 -15 -25 -21 -48 -6 -23 -20 -54 -30
-68 -10 -15 -19 -33 -19 -41 0 -7 -13 -40 -29 -73 -66 -138 -81 -173 -81 -184
0 -7 -8 -25 -19 -39 -10 -15 -21 -38 -25 -52 -9 -31 -67 -167 -130 -301 -14
-31 -26 -60 -26 -64 0 -8 -25 -64 -81 -179 -22 -45 -26 -63 -18 -73 9 -10 93
-13 429 -13 442 0 480 3 480 43 0 12 12 40 25 62 14 22 25 47 25 55 0 8 14 42
30 75 16 33 30 67 30 76 0 9 6 22 13 28 8 6 20 30 27 53 13 43 41 110 86 203
13 28 24 57 24 66 0 9 8 27 18 40 10 13 24 44 31 69 7 25 21 59 32 76 10 17
19 40 19 50 0 11 12 37 25 59 14 22 25 46 25 54 0 14 31 84 76 174 13 26 24
53 24 60 0 7 11 33 25 59 14 26 25 53 25 61 0 8 11 35 25 61 14 26 25 53 25
60 0 7 14 38 30 69 17 31 30 62 30 69 0 7 11 34 25 60 14 26 25 54 25 63 0 10
9 29 19 44 11 15 23 40 27 57 4 16 17 50 30 76 29 57 29 64 4 113 -11 21 -25
54 -31 74 -6 20 -20 50 -30 67 -11 17 -19 37 -19 44 0 7 -11 34 -25 62 -14 27
-25 54 -25 59 0 10 -31 80 -86 194 -13 28 -24 56 -24 63 0 7 -11 34 -25 60
-14 26 -25 54 -25 62 0 8 -12 33 -25 55 -14 22 -25 50 -25 61 0 12 -9 32 -19
46 -11 13 -23 36 -26 51 -12 48 -31 51 -50 10z"/>
<path d="M5392 10331 c-8 -5 -19 -53 -28 -122 -8 -63 -17 -120 -19 -128 -3 -7
-10 -93 -15 -190 -6 -97 -19 -237 -29 -311 -11 -74 -24 -214 -30 -311 -6 -96
-16 -191 -21 -210 -6 -19 -17 -133 -25 -254 -8 -121 -21 -258 -29 -305 -8 -47
-18 -154 -22 -239 -5 -125 -4 -155 7 -162 22 -14 373 -11 387 3 7 7 12 44 13
92 1 142 13 227 34 242 25 19 248 20 263 2 5 -7 15 -71 22 -142 15 -175 18
-186 49 -197 33 -13 357 -7 370 6 6 6 7 24 1 50 -5 22 -14 122 -20 223 -6 101
-17 222 -25 270 -9 48 -20 165 -26 262 -5 96 -19 236 -29 310 -10 74 -21 194
-25 265 -4 72 -15 191 -25 265 -10 74 -21 194 -25 265 -9 204 -23 293 -48 310
-18 13 -76 15 -357 15 -184 0 -341 -4 -348 -9z m389 -656 c6 -93 21 -269 34
-390 25 -224 35 -450 21 -473 -11 -19 -170 -16 -190 3 -17 17 -15 63 10 295 8
74 19 221 24 325 18 370 21 393 57 434 l18 21 8 -22 c5 -13 13 -99 18 -193z"/>
<path d="M6508 10329 c-17 -9 -18 -73 -18 -1114 0 -1082 0 -1105 19 -1115 11
-6 87 -10 175 -10 126 0 157 3 170 15 14 14 16 99 16 728 0 392 4 726 8 742
l9 30 10 -35 c6 -19 14 -53 18 -75 4 -22 15 -65 25 -95 9 -31 21 -94 25 -140
4 -47 16 -119 26 -160 11 -41 22 -109 26 -150 3 -41 12 -100 21 -130 8 -30 19
-95 24 -145 5 -49 18 -124 29 -166 10 -42 23 -117 28 -166 12 -117 39 -225 59
-240 19 -15 307 -18 344 -4 31 12 47 63 58 194 5 56 14 120 21 142 6 22 15 78
21 125 5 47 16 121 25 165 9 44 20 112 25 150 20 158 31 221 39 238 6 9 14 68
19 130 9 105 24 179 41 202 4 6 13 41 19 79 9 50 15 65 24 56 8 -8 12 -213 14
-737 2 -506 6 -731 14 -740 13 -16 302 -19 342 -3 l26 10 0 1105 0 1105 -26
10 c-40 16 -629 13 -641 -2 -6 -7 -13 -53 -16 -103 -3 -49 -15 -135 -25 -190
-11 -55 -25 -155 -31 -222 -6 -66 -15 -132 -20 -146 -6 -14 -15 -83 -21 -154
-6 -70 -20 -167 -31 -214 -10 -48 -19 -102 -19 -122 0 -45 -21 -137 -31 -137
-10 0 -16 19 -34 130 -9 52 -20 111 -25 130 -5 19 -14 91 -20 160 -6 69 -18
152 -26 184 -9 32 -19 113 -24 180 -5 67 -14 141 -20 166 -10 41 -23 142 -36
278 -5 45 -9 55 -30 63 -35 13 -604 11 -626 -2z"/>
<path d="M8602 10333 c-13 -3 -27 -14 -32 -26 -5 -12 -13 -105 -20 -205 -6
-101 -17 -218 -26 -260 -8 -43 -17 -135 -20 -207 -3 -71 -14 -193 -24 -270
-11 -77 -24 -214 -30 -305 -5 -91 -19 -226 -30 -300 -11 -74 -20 -175 -20
-225 0 -49 -9 -153 -20 -230 -26 -185 -26 -203 3 -210 29 -8 373 -2 381 6 9 8
36 217 36 274 0 28 5 56 12 63 8 8 51 12 129 12 160 0 154 7 169 -190 7 -94
17 -158 23 -162 14 -9 349 -11 371 -2 23 9 21 114 -4 283 -11 74 -24 216 -30
315 -5 100 -17 219 -25 266 -9 47 -20 164 -25 260 -5 96 -16 213 -24 260 -8
47 -20 168 -26 270 -6 102 -17 222 -25 267 -8 45 -17 130 -21 190 -4 59 -11
114 -17 121 -7 9 -87 12 -346 11 -185 -1 -346 -4 -359 -6z m364 -549 c7 -71
20 -178 28 -239 8 -60 18 -173 21 -250 3 -77 15 -212 26 -300 l21 -159 -22
-18 c-17 -14 -40 -18 -94 -18 -110 0 -110 0 -97 156 6 71 13 195 16 276 3 82
10 181 15 220 6 40 17 159 24 264 8 106 17 197 21 204 16 26 27 -13 41 -136z"/>
<path d="M9638 10329 c-16 -9 -18 -29 -18 -197 0 -133 4 -192 12 -200 7 -7 45
-12 98 -12 105 0 125 -5 139 -36 8 -18 11 -274 11 -899 0 -854 0 -875 19 -885
21 -11 340 -14 379 -4 l22 6 0 875 c0 645 3 880 12 896 21 40 40 46 134 47
128 0 124 -8 124 219 l0 181 -26 10 c-35 14 -883 13 -906 -1z"/>
<path d="M10748 10333 l-28 -4 0 -1114 0 -1114 55 -6 c30 -4 186 -5 347 -2
268 4 298 6 350 26 32 11 65 21 74 21 23 0 97 56 132 99 49 61 94 169 103 246
4 39 13 94 19 124 13 69 14 1162 0 1211 -5 19 -13 77 -18 127 -6 61 -16 102
-28 120 -10 16 -26 44 -35 63 -9 19 -23 41 -32 49 -10 7 -17 19 -17 26 0 18
-95 75 -153 92 -139 40 -168 43 -457 41 -157 0 -297 -3 -312 -5z m572 -412
c51 -36 50 -21 48 -711 -3 -627 -4 -646 -23 -672 -37 -50 -155 -76 -175 -39
-14 27 -14 1405 0 1432 9 17 18 18 68 13 31 -3 68 -14 82 -23z"/>
<path d="M12181 10331 c-33 -9 -37 -28 -44 -207 -4 -82 -13 -186 -22 -230 -8
-43 -22 -178 -30 -299 -9 -121 -20 -240 -25 -265 -5 -25 -17 -144 -25 -264 -9
-121 -20 -238 -25 -260 -5 -23 -14 -120 -20 -216 -6 -96 -20 -234 -30 -305
-27 -178 -27 -181 11 -189 55 -11 336 -7 363 5 22 10 25 20 35 108 6 53 12
122 14 153 5 85 10 88 142 88 149 0 152 -2 165 -130 5 -52 10 -120 10 -151 0
-30 5 -60 12 -67 8 -8 66 -12 194 -12 149 0 184 3 194 15 10 12 10 42 1 143
-6 71 -16 144 -21 163 -6 19 -15 116 -20 216 -9 161 -26 328 -35 343 -2 3 -8
84 -14 180 -6 96 -20 243 -31 325 -11 83 -24 227 -30 320 -5 94 -16 208 -24
255 -8 47 -17 125 -21 175 -3 49 -11 95 -17 102 -8 10 -87 13 -347 12 -185 -1
-347 -4 -360 -8z m366 -522 c7 -63 19 -166 27 -229 9 -63 18 -180 22 -260 3
-80 12 -194 20 -255 29 -219 29 -237 9 -251 -12 -9 -47 -14 -95 -14 -63 0 -80
3 -94 19 -10 11 -15 24 -12 29 3 5 10 115 16 243 6 129 17 292 25 364 9 71 20
203 25 293 6 90 13 168 16 174 17 27 30 -8 41 -113z"/>
<path d="M13218 10329 c-16 -9 -18 -29 -18 -193 0 -223 -6 -213 133 -218 84
-2 101 -6 113 -22 12 -17 14 -156 14 -903 0 -862 0 -883 19 -893 26 -13 366
-13 392 0 19 10 19 31 19 895 l0 884 26 20 c22 18 41 21 113 21 135 0 131 -7
131 214 l0 183 -25 11 c-34 16 -892 16 -917 1z"/>
<path d="M14453 10328 c-6 -7 -13 -65 -17 -129 -3 -64 -12 -154 -20 -200 -8
-46 -20 -167 -26 -269 -6 -102 -18 -223 -26 -269 -8 -46 -19 -159 -24 -250 -5
-91 -18 -227 -29 -301 -10 -74 -22 -195 -26 -269 -3 -74 -15 -191 -25 -260
-25 -160 -27 -276 -4 -285 9 -3 96 -6 194 -6 130 0 180 3 187 13 5 6 15 77 22
157 17 197 11 190 160 190 89 0 121 -3 130 -14 7 -8 21 -83 32 -167 15 -113
24 -157 36 -166 20 -15 349 -18 373 -3 17 10 16 44 -6 178 -8 51 -19 170 -24
265 -5 95 -16 213 -25 262 -8 50 -20 169 -25 265 -6 96 -18 217 -26 269 -8 52
-19 172 -24 265 -5 94 -16 208 -24 254 -9 46 -20 161 -26 255 -13 216 -12 213
-51 221 -17 3 -181 6 -364 6 -254 0 -335 -3 -342 -12z m398 -594 c5 -98 16
-226 25 -284 8 -58 19 -188 24 -290 5 -102 14 -218 20 -258 11 -67 10 -75 -7
-87 -22 -17 -155 -20 -184 -5 -22 12 -25 51 -9 145 6 33 17 186 25 340 8 154
22 327 30 385 8 58 18 130 22 160 7 64 20 97 34 83 5 -5 14 -90 20 -189z"/>
<path d="M16615 10333 c-30 -4 -97 -22 -189 -50 -97 -30 -246 -219 -246 -312
0 -17 -9 -64 -20 -103 -19 -69 -20 -103 -20 -683 0 -521 2 -617 16 -660 8 -27
19 -72 25 -100 5 -27 22 -68 36 -90 59 -88 188 -187 258 -200 21 -4 53 -14 70
-23 23 -12 61 -16 170 -16 126 0 144 2 180 22 21 12 46 22 53 22 19 0 95 47
144 89 50 43 97 136 115 226 8 43 16 169 20 325 l5 256 -26 12 c-28 13 -359
18 -390 6 -14 -5 -16 -34 -16 -218 0 -116 -4 -227 -10 -245 -16 -56 -56 -91
-105 -91 -53 0 -82 21 -95 70 -12 43 -15 1224 -4 1279 11 52 46 81 98 81 39 0
50 -5 73 -31 38 -41 40 -58 42 -256 0 -94 4 -178 7 -187 5 -14 32 -16 194 -16
168 0 189 2 203 18 15 16 17 46 17 208 0 231 -15 338 -58 413 -37 67 -89 121
-139 147 -20 10 -52 29 -70 41 -18 12 -52 24 -76 28 -23 4 -64 13 -92 20 -61
17 -130 24 -170 18z"/>
<path d="M17845 10329 c-91 -13 -229 -56 -268 -82 -48 -33 -106 -93 -132 -138
-10 -19 -30 -72 -44 -119 l-24 -85 -4 -639 c-3 -616 -3 -642 17 -717 11 -43
20 -86 20 -95 0 -10 14 -47 32 -83 38 -81 169 -215 220 -226 18 -4 60 -16 93
-27 88 -29 244 -28 307 1 26 11 56 21 68 21 28 0 124 53 158 87 90 91 130 180
153 343 17 120 19 195 19 690 0 505 -2 565 -20 665 -21 122 -48 184 -109 250
-59 64 -122 103 -193 119 -35 8 -81 19 -103 24 -63 15 -135 19 -190 11z m120
-407 c6 -4 22 -23 35 -42 l25 -35 3 -520 c4 -638 0 -728 -36 -784 -25 -39 -29
-41 -77 -41 -68 0 -90 23 -104 110 -14 85 -15 1147 -1 1221 13 69 44 99 103
99 23 0 47 -4 52 -8z"/>
<path d="M18678 10328 l-28 -10 0 -1103 c0 -872 3 -1106 13 -1112 17 -11 357
-17 368 -6 4 4 9 307 10 673 1 591 7 768 25 820 10 29 22 -12 34 -118 6 -56
17 -120 25 -142 8 -22 19 -84 25 -137 6 -54 17 -123 25 -153 9 -30 20 -100 25
-155 6 -55 17 -125 25 -155 9 -30 22 -108 30 -172 8 -64 20 -129 26 -145 5
-15 16 -82 24 -149 17 -143 20 -153 52 -165 38 -14 326 -12 344 4 19 15 56
176 64 280 3 42 14 110 24 150 11 39 22 113 26 162 4 50 15 122 25 160 10 39
22 108 25 155 4 47 15 119 25 160 10 41 23 122 29 179 13 125 20 153 35 148
35 -11 37 -43 36 -714 0 -400 4 -664 10 -673 7 -12 41 -16 171 -18 89 -2 173
-1 185 2 l24 6 0 1108 c0 848 -3 1111 -12 1120 -9 9 -94 12 -319 12 -255 0
-310 -2 -322 -14 -8 -8 -18 -45 -22 -81 -4 -36 -11 -80 -16 -98 -5 -18 -16
-99 -24 -180 -8 -82 -21 -174 -29 -205 -8 -31 -20 -119 -26 -194 -6 -76 -15
-150 -21 -164 -5 -15 -16 -90 -25 -168 -23 -219 -24 -221 -68 -97 -19 52 -29
109 -36 197 -10 119 -24 217 -35 233 -2 5 -11 77 -20 162 -8 84 -22 180 -29
214 -8 33 -20 116 -26 185 -13 155 -20 182 -51 197 -30 16 -579 17 -621 1z"/>
<path d="M15553 8450 c-21 -9 -22 -15 -25 -167 -2 -87 -2 -163 0 -169 2 -7 17
-15 34 -18 40 -8 372 -8 392 0 14 5 16 30 16 173 0 117 -4 171 -12 179 -14 14
-370 16 -405 2z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
